import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { Types } from "../actions/allowanceActions";

//import { v4 as uuidv4 } from 'uuid';

const allowanceReducers = (state, action) => {
	switch (action.type) {
		case Types.ALLOWANCE_UPDATE_LIST: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.allowances.allowanceList = action.payload.allowances;

			return newState;
		}
		case Types.ALLOWANCE_GOVT_BONUS_UPDATE_LIST: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.allowances.governmentBonuses = action.payload.governmentBonuses;

			return newState;
		}
		case Types.ALLOWANCES_UPLOADING: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.allowances.allowanceUploadProgress = action.progress;

			return newState;
		}
		case Types.ALLOWANCES_UPLOADED: {
			let newState = _.cloneDeep(state);

			newState.allowances.allowanceUploadProgress = null;
			newState.allowances.allowanceUploadErrors = action.payload.errors;

			return newState;
		}

		case Types.ALLOWANCES_ADD: {
			let newState = _.cloneDeep(state);

			if (action.id && action.newCompany) {
				newState.company.newCompany.allowances =
					(newState.company.newCompany.allowances && [...newState.company.newCompany.allowances]) || [];

				newState.company.newCompany.allowances.push({
					id: action.id,
				});

				return newState;
			}

			if (action.newCompany) {
				newState.company.newCompany.allowances =
					(newState.company.newCompany.allowances && [...newState.company.newCompany.allowances]) || [];
				newState.company?.newCompany?.allowances?.push({
					id: uuidv4(),
					public: "no",
				});
			} else {
				newState.company.settings.allowances =
					(newState.company.settings.allowances && [...newState.company.settings.allowances]) || [];
				newState.company?.settings?.allowances?.push({
					id: uuidv4(),
					public: "no",
					taxable: true,
					temporary: true,
				});
			}
			return newState;
		}
		case Types.ALLOWANCES_CLEAR: {
			let newState = _.cloneDeep(state);

			if (action.newCompany) {
				newState.company.newCompany.allowances = [];
			}

			return newState;
		}
		case Types.ALLOWANCES_ADVISOR_ADD: {
			let newState = _.cloneDeep(state);

			newState.advisors.settings.allowances =
				(newState.advisors.settings.allowances && [...newState.advisors.settings.allowances]) || [];

			newState.advisors?.settings?.allowances?.push({
				id: uuidv4(),
				public: "no",
				taxable: true,
				temporary: true,
			});

			return newState;
		}
		case Types.ALLOWANCES_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);
			if (action.newCompany)
				newState.company.newCompany.allowances.find((item) => item.id == action.id)[action.field] =
					action.newValue;
			else
				newState.company.settings.allowances.find((item) => item.id == action.id)[action.field] =
					action.newValue;
			return newState;
		}
		case Types.ALLOWANCES_ADVISOR_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);

			newState.advisors.settings.allowances.find((item) => item.id == action.id)[action.field] = action.newValue;

			return newState;
		}
		case Types.ALLOWANCES_APPLY_TEMPLATE: {
			let newState = _.cloneDeep(state);

			newState.company.newCompany.selectedAllowanceTemplate = action.template;

			return newState;
		}

		default:
			return state;
	}
};

export default allowanceReducers;
